import { useState } from "react";
import { NavLink } from "react-router-dom";
import './Navbar.css';

const links = [
    { to: '/', label: 'Home'},
    { to: '/about', label: 'About'},
    { to: '/listen', label: 'Listen'},
    { to: '/members', label: 'Members'},
    { to: '/schedule', label: 'Schedule'},
    { to: '/photos', label: 'Photos'},
    { to: '/contact', label: 'Contact'},
]

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    function handleLinkClick() {
        setMenuOpen(false);
    }

    return (
        <nav className="navbar">
            <div className="navbar-inner">
                <NavLink to="/" className="navbar-logo">Kazoku Quartet</NavLink>
                <button 
                    className={`hamburger ${menuOpen ? 'open' : ''}`}
                    onClick={()=> setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={menuOpen}
                    >
                        <span className="hamburger-line" />
                        <span className="hamburger-line" />
                        <span className="hamburger-line" />
                    </button>
                <ul className={`navbar-links ${menuOpen ? 'navbar-links--open' : ''}`}>
                    {links.map(({ to, label}) => (
                        <li key={to}>
                            <NavLink
                                to={to}
                                className={({ isActive }) => isActive? 'nav-link active' : 'nav-link'}
                                end={to === '/'}
                                onClick={handleLinkClick}
                        >
                            {label}
                            </NavLink>
                        </li>
                    ))}
                    <li className="navbar-social-mobile">
                        <a
                            href="https://www.instagram.com/kazokuquartet"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link"
                            aria-label="Instagram"
                        >
                            Instagram
                        </a>
                    </li>
                </ul>
                <a
                    href="https://www.instagram.com/kazokuquartet"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="navbar-social"
                    aria-label="Instagram"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5Zm4.25 3.25a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm0 1.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm5.5-1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>
                    </svg>
                </a>
            </div>
        </nav>

    );
}

export default Navbar;